import { render, staticRenderFns } from "./alerts-data.vue?vue&type=template&id=7d075c6b"
import script from "./alerts-data.vue?vue&type=script&lang=js"
export * from "./alerts-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports